import React from "react";
import { MEDIA } from "../lib/site";
import Reveal from "../components/Reveal";

const PILLARS = [
    { t: "Virgin Material First", d: "We invest in virgin polymers, masterbatches, and UV systems before anything else. The product writes the rest." },
    { t: "Hands on every roll", d: "Each batch is touched, gauged, and signed off by humans before it leaves the floor." },
    { t: "Long-term partnership", d: "We grow with our buyers — bespoke profiles, exclusive colourways, and supply you can plan around." },
];

const TIMELINE = [
    { y: "2014", t: "Founding", d: "A single extrusion line, a small team, and an obsession with consistency." },
    { y: "2018", t: "Export milestone", d: "First containers ship to global markets; partnerships with founding furniture houses begin." },
    { y: "2021", t: "Rope division", d: "PP rope manufacturing brought in-house, expanding the catalogue." },
    { y: "2024", t: "5+ countries", d: "Today our materials are woven into outdoor pieces across multiple countries." },
];

const About = () => {
    return (
        <div data-testid="about-page">
            {/* Header */}
            <section className="pt-12 pb-20 lg:pt-20 lg:pb-28">
                <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-7">
                        <Reveal>
                            <div className="text-xs uppercase tracking-widest2 text-copper mb-6">— About Shaurya</div>
                            <h1 className="font-serif text-5xl lg:text-7xl font-light text-forest leading-[0.95] tracking-tight">
                                A decade of <span className="italic text-copper">making</span> material that lasts.
                            </h1>
                        </Reveal>
                        <Reveal delay={150}>
                            <p className="mt-8 text-lg text-charcoal/75 max-w-xl leading-relaxed">
                                Shaurya Polymers Private Limited is a privately held manufacturer of synthetic outdoor furniture
                                materials, headquartered in India. We make PE wicker, synthetic rattan, and ropes — and export quality Furniture.
                            </p>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-5">
                        <Reveal delay={250}>
                            <div className="aspect-[4/5] overflow-hidden border border-line">
                                <img src={MEDIA.facility} alt="Facility" className="w-full h-full object-cover" />
                            </div>
                        </Reveal>
                    </div>
                </div>
            </section>

            {/* Pillars */}
            <section className="py-20 bg-surface-alt border-y border-line">
                <div className="max-w-7xl mx-auto px-6 md:px-12">
                    <Reveal>
                        <div className="text-xs uppercase tracking-widest2 text-copper mb-4">— Our principles</div>
                        <h2 className="font-serif text-4xl lg:text-5xl text-forest max-w-2xl leading-tight">Three commitments that shape every roll.</h2>
                    </Reveal>
                    <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
                        {PILLARS.map((p, i) => (
                            <Reveal key={i} delay={i * 120}>
                                <div className="border-t border-forest/30 pt-6">
                                    <div className="text-xs uppercase tracking-widest2 text-charcoal/50">0{i + 1}</div>
                                    <div className="font-serif text-3xl text-forest mt-3">{p.t}</div>
                                    <p className="mt-4 text-base text-charcoal/75 leading-relaxed">{p.d}</p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            {/* Timeline */}
            <section className="py-24 lg:py-32">
                <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <Reveal>
                            <div className="text-xs uppercase tracking-widest2 text-copper mb-6">— Heritage</div>
                            <h2 className="font-serif text-4xl lg:text-5xl text-forest leading-tight">
                                A quiet, deliberate climb.
                            </h2>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-8">
                        <ol className="space-y-10 border-l border-line pl-8">
                            {TIMELINE.map((m, i) => (
                                <Reveal key={i} delay={i * 100}>
                                    <li className="relative">
                                        <span className="absolute -left-[37px] top-3 w-2 h-2 bg-copper" />
                                        <div className="font-serif text-3xl text-copper">{m.y}</div>
                                        <div className="text-lg text-forest font-medium mt-1">{m.t}</div>
                                        <p className="mt-2 text-charcoal/75 max-w-2xl leading-relaxed">{m.d}</p>
                                    </li>
                                </Reveal>
                            ))}
                        </ol>
                    </div>
                </div>
            </section>

            {/* Quote */}
            <section className="pb-24">
                <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
                    <Reveal>
                        <p className="font-serif italic text-3xl lg:text-4xl text-forest leading-tight text-balance">
                            "What we make is more than Rattan and Rope. It's confidence, reliability, and the pride of knowing every batch meets the standards we would expect ourselves."
                        </p>
                        <div className="mt-6 text-xs uppercase tracking-widest2 text-charcoal/60">— Founder's note</div>
                    </Reveal>
                </div>
            </section>
        </div>
    );
};

export default About;
